import { useContext } from 'react';
import { UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { DEFAULT_ERROR_MESSAGE } from '../../Base.constants';
import { ToastContext } from '../../context/ToastContext';
import { SendFeedbackRequest, sendFeedback } from '../../services/chat/feedback.service';
import { Session } from '../../services/chat/getSessions.service';
import { queryKeys } from '../queryKeyFactory';

export const useSendFeedback = (
  onSuccess?: (positive: boolean) => void
): UseMutationResult<void, Error, SendFeedbackRequest> => {
  const queryClient = useQueryClient();
  const toast = useContext(ToastContext);

  return useMutation((request: SendFeedbackRequest) => sendFeedback(request), {
    onSuccess: (_, request) => {
      const sessions: Session[] = queryClient.getQueryData([queryKeys.chat.getSessions]) ?? [];
      const currentSession = sessions?.find((item) => item.session_id === request.sessionId);

      if (currentSession) {
        const history = [...currentSession.session_history];
        const prevIndex = history.findIndex((item) => item.query_seq_id === request.seqId);

        if (prevIndex >= 0) {
          history.splice(prevIndex, 1, {
            ...history[prevIndex],
            user_feedback_type: request.user_feedback_type,
            usr_thumbs_up: request.feedback_body.user_thumbs_up,
            usr_comments: request.comments,
            ui_show_feedback_form:
              (request.feedback_body.user_thumbs_up &&
                !!history[prevIndex].source_documents?.length &&
                !request.feedback_body.user_thumbsup_feedback) ||
              (!request.feedback_body.user_thumbs_up && !request.feedback_body.user_thumbsdown_feedback),
          });

          queryClient.setQueryData(
            [queryKeys.chat.getSessions],
            [
              ...sessions.filter((item) => item.session_id !== currentSession.session_id),
              {
                ...currentSession,
                session_history: history,
              },
            ]
          );

          onSuccess?.(request.feedback_body.user_thumbs_up);
        }
      }
    },
    onError: () => {
      toast.error(DEFAULT_ERROR_MESSAGE);
    },
  });
};
